import * as Yup from 'yup';
import { FinalCausalityFilter } from '../../../../../shared/types/typifications/finalCausality';

export const initialValues: FinalCausalityFilter = {
    finalCausality: '',
    causeNumber: '',
    realCause: '',
    active: true,
};

export const validationSchema = () => Yup.object({});
